import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Every internal link opens the room at the top — never halfway down by the footer. */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
    }, []);

    useEffect(() => {
        if (!hash) { window.scrollTo(0, 0); return; }
        // The room may still be mounting — look for it for a beat, then land on it.
        let tries = 0;
        const find = () => {
            const el = document.getElementById(hash.slice(1));
            if (el) { el.scrollIntoView({ behavior: "smooth", block: "start" }); return; }
            if (tries++ < 20) window.setTimeout(find, 60);
        };
        find();
    }, [pathname, hash]);

    return null;
}
